import mapProps from '../scripts/utils/map-props';
import RadioGroup from './radio-group';

export default mapProps(
  [
    'value',
  ],
  {
    model: {
      prop: 'value',
      event: 'change',
    },
  }
)(RadioGroup);
